import { createContext, FC, PropsWithChildren, useCallback, useRef, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const Context = createContext<() => Promise<void>>(() => Promise.resolve())

export const PromptContext: FC<PropsWithChildren<{}>> = ({ children }) => {
  const cbReject = useRef<() => void>(() => {})
  const cbResolve = useRef<() => void>(() => {})
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  const showPrompt = useCallback(
    () =>
      new Promise<void>((resolve, reject) => {
        cbReject.current = reject
        cbResolve.current = resolve
        setOpen(true)
      }),
    []
  )

  const close = useCallback(() => {
    if (cbReject.current) {
      cbReject.current()
    }
    setOpen(false)
  }, [])

  const confirm = useCallback(() => {
    if (cbResolve.current) {
      cbResolve.current()
    }
    setOpen(false)
  }, [])

  return (
    <Context.Provider value={showPrompt}>
      {children}
      <Dialog open={open} onClose={close}>
        <DialogTitle>{t('components.prompt.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('components.prompt.body')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button data-test="prompt-stay-button" variant="text" onClick={close}>
            {t('components.prompt.buttonStay')}
          </Button>
          <Button autoFocus data-test="prompt-leave-button" variant="contained" onClick={confirm}>
            {t('components.prompt.buttonLeave')}
          </Button>
        </DialogActions>
      </Dialog>
    </Context.Provider>
  )
}
